import { useMemo } from 'react';
import * as FormulaActionMetadataKeys from 'automation-ui-action-features/actions/formula/FormulaActionMetadataKeys';
import { findVariableContext, fromTemplateString } from 'automation-ui-action-features/actions/formula/formulaParsers';
import Code from 'UIComponents/elements/Code';
import HR from 'UIComponents/elements/HR';
import UIList from 'UIComponents/list/UIList';
import DataSourceDescription from 'automation-ui-action-features/actions/formula/DataSourceDescription';
import parseWithErrors from 'automation-ui-formula-editor/formula-editor/grammar/parseWithErrors';
/* @ts-expect-error untyped module */
import hubLParser from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
import { isSimpleHubLExpression } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
import FormulaSummary from 'automation-ui-formula-editor/formula-editor/FormulaSummary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const renderOutputValue = ({
  fieldKey,
  value
}) => /*#__PURE__*/_jsxs("span", {
  children: [/*#__PURE__*/_jsx(Code, {
    children: fieldKey
  }), ": ", value]
});
const FormulaActionDetail = ({
  actionId,
  actionMetadata,
  flowObjectTypeId,
  getHeaderTitle,
  inline,
  outputValues,
  getActionOutputsForTargetActionById
}) => {
  const formulaTemplate = actionMetadata.get(FormulaActionMetadataKeys.TEMPLATE);
  const {
    parsedExpression = {},
    syntaxErrors
  } = useMemo(() => parseWithErrors({
    parse: hubLParser.parse,
    input: formulaTemplate
  }), [formulaTemplate]);
  const isSimpleExpression = useMemo(() => !syntaxErrors.length && isSimpleHubLExpression(parsedExpression), [syntaxErrors.length, parsedExpression]);
  const {
    variable,
    hubLFilter
  } = fromTemplateString({
    objectTypeId: flowObjectTypeId,
    formulaTemplate
  });
  const variableContexts = actionMetadata.get(FormulaActionMetadataKeys.VARIABLE_CONTEXT);
  if (isSimpleExpression) {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(DataSourceDescription, {
        getHeaderTitle: getHeaderTitle,
        objectTypeId: flowObjectTypeId,
        variable: variable,
        variableContext: findVariableContext(variable, variableContexts),
        actionOutputsForTargetActionById: getActionOutputsForTargetActionById(actionId)
      }), hubLFilter && /*#__PURE__*/_jsxs(_Fragment, {
        children: [!inline && /*#__PURE__*/_jsx(HR, {
          distance: "extra-small"
        }), /*#__PURE__*/_jsx(Code, {
          children: hubLFilter
        })]
      }), outputValues && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "extra-small"
        }), /*#__PURE__*/_jsx(UIList, {
          children: outputValues.map(renderOutputValue)
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsx(FormulaSummary, {
    parsedExpression: parsedExpression
  });
};
export default FormulaActionDetail;